module.exports = __webpack_public_path__ + "static/hr_capabilities_2-1d9defd7455cffc35158f4ae1afe1826.png";